import React from 'react';
import posed from 'react-pose';
import { modalConsControl } from "../../wrappers/modalConsControl";
import ModelSheet from "./displayModels/ModelSheet";
import add from "./../../../media/icons/add.svg"
import ModalModel from "./displayModels/ModalModel";
import ModalLoading from "../../shared/wait/ModalLoading";
import ModalVespa from "./displayVespas/ModalVespa";
import { ToolTip } from "../../shared/allToolTips";

const ModelDiv = posed.div({
  hoverable: true,
  init: {
    y: 0,
    transition: { duration: 100 }
  },
  hover: {
    y: 15,
    transition: { duration: 100 }
  }
});


const DisplayModels = ({ changeModal, models, updateRentals, updateModels }) => {

  const changeModel = (model = null, id = null) => {
    changeModal(<ModalLoading text="Cargando modelo..."/>);
    setTimeout(() => changeModal(<ModalModel changeModal={changeModal} updateRentals={updateRentals}
                                             updateModels={updateModels} model={model} id={id}/>), 500)
  };

  const openModalVespa = () =>
    changeModal(<ModalVespa updateRentals={updateRentals} models={models}/>);

  return (
    <React.Fragment>
      <ToolTip.MoreModels/>
      <ToolTip.MoreVespas/>
      <div className="container-fluid py-4">
        <div className="row justify-content-center px-2">
          {
            Object.keys(models).map((id) =>
              <ModelDiv style={{ cursor: "pointer" }} onClick={() => changeModel(models[id], id)} key={id}
                        className="col-auto m-2 border border-primary">
                <div style={{ maxWidth: "250px" }} className="row justify-content-center">
                  <ModelSheet model={models[id]}/>
                </div>
              </ModelDiv>
            )
          }
          <ModelDiv data-tip data-for='moreModels' style={{ cursor: "pointer", minHeight: "388px" }}
                    onClick={() => changeModel()}
                    className="col-auto m-2 border border-primary">
            <div style={{ maxWidth: "250px", width: "500px" }} className="row h-100 justify-content-center">
              <div className="container-fluid h-100 text-primary bg-white">
                <div className="row justify-content-center align-items-center h-75">
                  <img style={{ opacity: 0.9 }} src={add} alt=""/>
                </div>
                <div className="row justify-content-center align-items-center h-25 ff-bobby text-primary"
                     style={{ fontSize: "30px" }}>
                  MODELOS
                </div>
              </div>
            </div>
          </ModelDiv>
          <ModelDiv data-tip data-for='moreVespas' style={{ cursor: "pointer", minHeight: "388px" }}
                    onClick={openModalVespa}
                    className="col-auto m-2 border border-primary">
            <div style={{ maxWidth: "250px", width: "500px" }} className="row h-100 justify-content-center">
              <div className="container-fluid h-100 text-primary bg-white">
                <div className="row justify-content-center align-items-center h-75">
                  <img style={{ opacity: 0.9 }} src={add} alt=""/>
                </div>
                <div className="row justify-content-center align-items-center h-25 ff-bobby text-primary"
                     style={{ fontSize: "30px" }}>
                  VESPAS
                </div>
              </div>
            </div>
          </ModelDiv>
        </div>
      </div>
    </React.Fragment>
  );
}

export default modalConsControl(DisplayModels)
